<table mat-table [dataSource]="rows" class="w-full shadow-none">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Nom</th>
    <td mat-cell *matCellDef="let row">
      <span class="flex items-center gap-2">
        <mat-icon class="text-primary">groups</mat-icon>
        {{ row.team.name }}
      </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef>Rôle</th>
    <td mat-cell *matCellDef="let row">{{ row.team.role }}</td>
  </ng-container>
  <ng-container matColumnDef="support">
    <th mat-header-cell *matHeaderCellDef>Établissement support</th>
    <td mat-cell *matCellDef="let row" class="text-secondary">{{ row.team.support.name }}</td>
  </ng-container>
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>Adresse commune</th>
    <td mat-cell *matCellDef="let row" class="text-secondary">{{ row.team.email }}</td>
  </ng-container>
  <ng-container matColumnDef="members">
    <th mat-header-cell *matHeaderCellDef>Membres</th>
    <td mat-cell *matCellDef="let row">
      <span class="flex items-center gap-2">
        <span [matTooltip]="row.membersLabel">{{ row.team.members.length }}</span>
        <mat-icon *ngIf="row.issueLabel" class="text-warn" [matTooltip]="row.issueLabel">error</mat-icon>
      </span>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    [class.cursor-pointer]="linkable"
    (click)="open(row)"
  ></tr>
</table>
